import React from 'react'
import { Link } from 'react-router-dom'
import Footer_1 from '../../assets/images/footer-logo.svg'
import Footer_2 from '../../assets/images/footer-icon/footer-one-1.svg'
import Footer_3 from '../../assets/images/footer-icon/footer-one-2.svg'
import Footer_4 from '../../assets/images/footer-icon/footer-one-3.svg'
import Footer_5 from '../../assets/images/footer-icon/footer-one-4.svg'
import Footer_6 from '../../assets/images/footer-icon/footer-one-5.svg'
import Footer_7 from '../../assets/images/footer-icon/footer-one-6.svg'
import Footer_8 from '../../assets/images/footer-icon/footer-one-7.svg'
import Footer_9 from '../../assets/images/footer-icon/footer-one-8.svg'
import Footer_10 from '../../assets/images/footer-icon/footer-one-9.svg'
import Footer_11 from '../../assets/images/footer-icon/footer-one-10.svg'
import Footer_12 from '../../assets/images/svg/arrow-link.svg'


const Footer1 = () => {
    return (
        <>
            <div className="main-footer">
                {/* footer one start */}
                <footer className="footer-one">
                    <div className="container-fluid">
                        <div className="row gutter-y-30">
                            <div className="col-xl-4">
                                <div
                                    className="footer-about-one animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                >
                                    <div className="footer-logo-one">
                                        <img src={Footer_1} alt="logo" />
                                    </div>
                                    <h4>
                                        Professional &amp; modern, a theme designed to help your business
                                        stand out from the rest.
                                    </h4>
                                    <p className="lead">
                                        We understand that business can be chaotic. That’s where we come
                                        in. We’re focused on adding.
                                    </p>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div
                                    className="footer-widget-one animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    <h4>Services</h4>
                                    <ul className="footer-menu-one">
                                        <li>
                                            <img
                                                src={Footer_2}
                                                alt="icon"
                                            />
                                            <Link to="/ServiceDetails">Financial Analysis</Link>
                                        </li>
                                        <li>
                                            <img
                                                src={Footer_3}
                                                alt="icon"
                                            />
                                            <Link to="/ServiceDetails">Work organization</Link>
                                        </li>
                                        <li>
                                            <img
                                                src={Footer_4}
                                                alt="icon"
                                            />
                                            <Link to="/ServiceDetails">Digital Marketing</Link>
                                        </li>
                                        <li>
                                            <img
                                                src={Footer_5}
                                                alt="icon"
                                            />
                                            <Link to="/ServiceDetails">Innovation space</Link>
                                        </li>
                                        <li>
                                            <img
                                                src={Footer_6}
                                                alt="icon"
                                            />
                                            <Link to="/ServiceDetails">Risk Advisory</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-6">
                                <div
                                    className="footer-widget-one animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="400ms"
                                >
                                    <h4>Pages</h4>
                                    <ul className="footer-menu-one">
                                        <li>
                                            <img
                                                src={Footer_7}
                                                alt="icon"
                                            />
                                            <Link to="/Aboutus">About</Link>
                                        </li>
                                        <li>
                                            <img
                                                src={Footer_8}
                                                alt="icon"
                                            />
                                            <Link to="/Careers">Career</Link>
                                        </li>
                                        <li>
                                            <img
                                                src={Footer_9}
                                                alt="icon"
                                            />
                                            <Link to="/Careers">Applications</Link>
                                        </li>
                                        <li>
                                            <img
                                                src={Footer_10}
                                                alt="icon"
                                            />
                                            <Link to="/Contact">Contact Us</Link>
                                        </li>
                                        <li>
                                            <img
                                                src={Footer_11}
                                                alt="icon"
                                            />
                                            <Link to="/Portfolio">Case Studies</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4">
                                <div
                                    className="footer-newslatter-one animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="600ms"
                                >
                                    <h4>Newsletter </h4>
                                    <form action="#">
                                        <div className="newslatter-form-group">
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="Enter your email"
                                                className="form-control"
                                                required=""
                                            />
                                            <button type="submit" className="btn-link">
                                                <img src={Footer_12} alt="icon" />
                                            </button>
                                        </div>
                                    </form>
                                    <ul className="footer-social-media-one">
                                        <li>
                                            <Link to="https://www.facebook.com/">
                                                <i className="fa-brands fa-facebook-f" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://x.com/">
                                                <i className="fa-brands fa-twitter" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://www.instagram.com/">
                                                <i className="fa-brands fa-instagram" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://in.linkedin.com/">
                                                <i className="fa-brands fa-linkedin-in" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="footer-lower-one">
                                    <p className="lead">
                                        © Copyright@&nbsp;Uniqo&nbsp;All rights reserved
                                    </p>
                                    <ul>
                                        <li>
                                            <Link to="/Aboutus">Terms and conditions</Link>
                                        </li>
                                        <li>
                                            <span>|</span>
                                        </li>
                                        <li>
                                            <Link to="/Aboutus">Privacy policy</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>

        </>
    )
}

export default Footer1
